import { DividerProps } from "@material-ui/core/Divider"
import React from "react"
import { StyledDivider } from "./style"

const Divider = (props: DividerProps) => <StyledDivider {...props} />

export default Divider
